import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import CategoryResultCard from './CategoryResultCard';
import PredictionSummary from './PredictionSummary';
export default class ResultsView extends Component {
  view() {
    const award = this.attrs.award;
    const selectedCategoryId = this.attrs.selectedCategoryId;
    const allCategories = award.categories() || [];

    // Filter categories if a specific category is selected
    const categories = selectedCategoryId ? allCategories.filter(cat => String(cat.id()) === selectedCategoryId) : allCategories;

    // Check if this is an early preview (ended but not published)
    const isEarlyPreview = award.hasEnded() && !award.isPublished();
    return m("div", {
      className: "ResultsView"
    }, isEarlyPreview ? m("div", {
      className: "Alert Alert--info AwardsPage-previewAlert"
    }, m("i", {
      className: "fas fa-eye"
    }), " ", app.translator.trans('huseyinfiliz-awards.forum.preview.admin_only')) : null, app.session.user && !selectedCategoryId ? m(PredictionSummary, {
      award: award,
      categories: allCategories
    }) : null, m("div", {
      className: "ResultsView-content"
    }, categories.length === 0 ? m("div", {
      className: "EmptyState"
    }, m("p", null, app.translator.trans('huseyinfiliz-awards.forum.empty.no_categories'))) : categories.map(category => m(CategoryResultCard, {
      category: category,
      award: award
    }))));
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/ResultsView', ResultsView);